export default __webpack_public_path__ + "static/media/guestbook.e3317aec.jpg";